var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHyperLinkBlue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.08333 1.75V2.91667H1.16667V9.33333H7.58333V6.41667H8.75V9.91667C8.75 10.0714 8.68854 10.2197 8.57915 10.3291C8.46975 10.4385 8.32138 10.5 8.16667 10.5H0.583333C0.428624 10.5 0.280251 10.4385 0.170854 10.3291C0.0614581 10.2197 0 10.0714 0 9.91667V2.33333C0 2.17862 0.0614581 2.03025 0.170854 1.92085C0.280251 1.81146 0.428624 1.75 0.583333 1.75H4.08333ZM10.5 0V5.25L8.28683 3.03742L4.78742 6.53742L3.96258 5.71258L7.462 2.21258L5.25 0H10.5Z",
    fill: "#1C64F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHyperLinkBlue);
export default __webpack_public_path__ + "static/media/hyperLinkBlue.800cce4ff37e6b8efd120cdf4e70391e.svg";
export { ForwardRef as ReactComponent };